import { getFrameworks } from "@/getters/getFrameworks";
import clsx from "classnames";
import { Stack } from "react-bootstrap";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";

export const Frameworks = ({ className }) => {
  const frameworks = getFrameworks();

  return (
    <Stack className={clsx(className, "flex-row justify-content-center")} gap={{ xs: 0, md: 4 }}>
      {frameworks.map((i) =>
        "url" in i ? (
          <a key={i.id} href={i.url} rel="nofollow">
            <SourceFlowImage className="w-100" size="x180" style={{ maxHeight: 90 }} src={i.logo} alt={i.title} />
          </a>
        ) : (
          <span key={i.id}>
            <SourceFlowImage className="w-100" size="x180" style={{ maxHeight: 90 }} src={i.logo} alt={i.title} />
          </span>
        )
      )}
    </Stack>
  );
};
